// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"popover-wrapper--SGaj3","popover-content":"popover-content--KzQzU"};